export default __webpack_public_path__ + "static/media/survey3.e71a1473.svg";